import { render, staticRenderFns } from "./exchangeIcon.vue?vue&type=template&id=499460e3&"
import script from "./exchangeIcon.vue?vue&type=script&lang=js&"
export * from "./exchangeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports